import { render, staticRenderFns } from "./SDParaklassen.vue?vue&type=template&id=691eeb0c&scoped=true&"
import script from "./SDParaklassen.vue?vue&type=script&lang=js&"
export * from "./SDParaklassen.vue?vue&type=script&lang=js&"
import style0 from "./SDParaklassen.vue?vue&type=style&index=0&id=691eeb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691eeb0c",
  null
  
)

export default component.exports